export default "__VITE_ASSET__Dxf63iZd__"